import { render } from "./TableUi.vue?vue&type=template&id=32d46e44"
import script from "./TableUi.vue?vue&type=script&lang=js"
export * from "./TableUi.vue?vue&type=script&lang=js"

import "./TableUi.vue?vue&type=style&index=0&id=32d46e44&lang=scss"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__